var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("body", [
      _c(
        "div",
        { staticClass: "voucher voucher_queenTi" },
        [
          _c("h1", { staticClass: "read-only" }, [
            _vm._v("암웨이 퀸 Ti 크라운세트 사은품 교환권 페이지")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("coupondetailvue", {
            attrs: {
              propCouponInfo: this.propCouponInfo,
              propCouponDetail: this.propCouponDetail,
              aboInfo: this.aboInfo,
              couponNo: this.couponNo
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "header" }, [
      _c("div", { staticClass: "item" }, [
        _c("img", {
          attrs: {
            src: require("./assets/images/queenTi/queenTi_coupon.png"),
            alt:
              "암웨이 퀸 Ti 크라운세트 사은품 교환권 (DIA이상 사전 출시 대상) 극세사 디쉬 타올 3종"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03cebbcd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03cebbcd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/couponsys/queenti.vue
// module id = null
// module chunks = 